export default __webpack_public_path__ + "static/artifakt-element-black-275c0d6ebefbb7a9e327a6ae41e93259.eot";